import { render, staticRenderFns } from "./UploadProofWire.vue?vue&type=template&id=f9f983c6&scoped=true"
import script from "./UploadProofWire.vue?vue&type=script&lang=js"
export * from "./UploadProofWire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f983c6",
  null
  
)

export default component.exports